import type { EmblaPluginType } from 'embla-carousel';

import AutoHeight from 'embla-carousel-auto-height';
import AutoScroll from 'embla-carousel-auto-scroll';
import Autoplay from 'embla-carousel-autoplay';
import Fade from 'embla-carousel-fade';

interface AutoplayOptions {
  delay?: number;
  stopOnInteraction?: boolean;
  stopOnMouseEnter?: boolean;
  stopOnFocusIn?: boolean;
  playOnInit?: boolean;
  rootNode?: ((emblaRoot: HTMLElement) => HTMLElement | null) | null;
}

interface AutoScrollOptions {
  speed?: number;
  startDelay?: number;
  direction?: 'forward' | 'backward';
  playOnInit?: boolean;
  stopOnInteraction?: boolean;
  stopOnMouseEnter?: boolean;
  stopOnFocusIn?: boolean;
  rootNode?: ((emblaRoot: HTMLElement) => HTMLElement | null) | null;
}

interface UseCarouselPluginsOptions {
  autoplay?: boolean | AutoplayOptions;
  autoScroll?: boolean | AutoScrollOptions;
  autoHeight?: boolean;
  fade?: boolean;
}

export const useCarouselPlugins = function (options: UseCarouselPluginsOptions = {}): EmblaPluginType[] {
  const plugins: EmblaPluginType[] = [];

  // Autoplay plugin
  if (options.autoplay) {
    const defaultOptions: AutoplayOptions = {
      delay: 3500,
      stopOnInteraction: false,
      stopOnMouseEnter: true,
      playOnInit: true,
    };

    const userOptions = typeof options.autoplay === 'object' ? options.autoplay : {};

    plugins.push(Autoplay({ ...defaultOptions, ...userOptions }));
  }

  // AutoScroll plugin
  if (options.autoScroll) {
    const defaultOptions: AutoScrollOptions = {
      speed: 2,
      startDelay: 1000,
      direction: 'forward',
      playOnInit: true,
      stopOnInteraction: true,
      stopOnMouseEnter: false,
    };

    const userOptions = typeof options.autoScroll === 'object' ? options.autoScroll : {};

    plugins.push(AutoScroll({ ...defaultOptions, ...userOptions }));
  }

  // AutoHeight plugin
  if (options.autoHeight) {
    plugins.push(AutoHeight());
  }

  // Fade plugin
  if (options.fade) {
    plugins.push(Fade());
  }

  return plugins;
};
